
import React from 'react';
import { Facility } from '../../types';
import FacilitySwitcher from './FacilitySwitcher';
import { facilities } from '../../constants';

/**
 * Props for the Header component.
 */
interface HeaderProps {
  selectedFacility: Facility;
  onFacilityChange: (id: number) => void;
  currentUser: string;
  onLogout: () => void;
}

/**
 * The main application header component. It is a sticky header that contains
 * the facility switcher.
 * @param {HeaderProps} props - The props for the component.
 * @returns {React.ReactElement} - The rendered header.
 */
const Header: React.FC<HeaderProps> = ({ selectedFacility, onFacilityChange, currentUser, onLogout }) => {
  console.log(selectedFacility)
  return (
    <header className="bg-white shadow-md sticky top-0 z-20">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0 max-w-[50%] sm:max-w-[70%] flex items-center gap-3">
            {/* <FacilitySwitcher 
                facilities={facilities}
                selectedFacility={selectedFacility}
                onFacilityChange={onFacilityChange}
            /> */}
            <img
              src={selectedFacility.logoUrl}
              alt={`${selectedFacility.name} logo`}
              className="h-10 w-10 object-cover rounded-md flex-shrink-0"
            />
            <span className="font-semibold text-gray-800 truncate">
              {selectedFacility.name}
            </span>
          </div>
          
          {/* User Profile Section */}
          <div className="flex items-center gap-2 sm:gap-3 pl-3 sm:pl-4 border-l border-gray-200 ml-2 sm:ml-4 flex-shrink-0">
             <div className="flex flex-col items-end">
                <span className="hidden sm:inline text-[10px] uppercase tracking-wider text-gray-500 font-bold">Staff ID</span>
                <span className="text-sm font-black text-indigo-700 bg-indigo-50 px-2 py-0.5 rounded sm:bg-transparent sm:p-0 sm:text-gray-800" title="Logged in Employee ID">
                    {currentUser}
                </span>
             </div>
             <div className="h-8 w-8 sm:h-9 sm:w-9 rounded-full bg-indigo-100 flex items-center justify-center border border-indigo-200 text-indigo-700 font-bold shadow-sm" title={`Logged in as ${currentUser}`}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                </svg>
             </div>
             <button
                onClick={onLogout}
                className="p-1.5 sm:p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-red-500"
                title="Logout"
                aria-label="Logout"
             >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
             </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
